"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var presentation_exports = {};
__export(presentation_exports, {
  openApiErrorMessage: () => openApiErrorMessage,
  openApiPresentation: () => openApiPresentation,
  sanitizeNote: () => sanitizeNote
});
module.exports = __toCommonJS(presentation_exports);
function openApiPresentation(result, mode, state) {
  const parsed = result?.document;
  const spec = mode === "preview" && parsed !== void 0 ? parsed.spec : void 0;
  const showPreview = spec !== void 0;
  return {
    showPreview,
    spec,
    message: presentationMessage(result, state),
    messageIsError: result?.error !== void 0,
    note: parsed !== void 0 ? sanitizeNote(parsed.report) : void 0,
    canToggle: parsed !== void 0,
    toggleTitle: showPreview ? "Show the specification" : "Show the documentation",
    label: blockLabel(result)
  };
}
__name(openApiPresentation, "openApiPresentation");
function presentationMessage(result, state) {
  if (result?.error !== void 0) return openApiErrorMessage(result.error);
  if (state === "loading") {
    const url = result?.source.url;
    return url !== void 0 ? `Loading ${url}\u2026` : "Loading\u2026";
  }
  if (result?.loadedFrom !== void 0) return `Loaded from ${result.loadedFrom}`;
  if (result?.source.kind === "empty") {
    return "Paste an OpenAPI 3.x specification in YAML or JSON, or the address of one.";
  }
  return void 0;
}
__name(presentationMessage, "presentationMessage");
function openApiErrorMessage(error) {
  return error.line !== void 0 ? `Line ${error.line}: ${error.message}` : error.message;
}
__name(openApiErrorMessage, "openApiErrorMessage");
const namedRefs = 3;
function sanitizeNote(report) {
  const parts = [];
  if (report.externalRefs.length > 0) {
    const shown = report.externalRefs.slice(0, namedRefs).join(", ");
    const rest = report.externalRefs.length - namedRefs;
    parts.push(
      rest > 0 ? `Not shown, and not fetched: ${shown} and ${rest} more reference${rest === 1 ? "" : "s"} outside this document.` : `Not shown, and not fetched: ${shown}.`
    );
  }
  if (report.rejectedUrls.length > 0) {
    const count = report.rejectedUrls.length;
    parts.push(`${count} address${count === 1 ? "" : "es"} removed for not being http or https.`);
  }
  if (report.strippedEmbeds > 0) {
    const count = report.strippedEmbeds;
    parts.push(`Embedded content removed from ${count} description${count === 1 ? "" : "s"}.`);
  }
  if (report.cycles > 0) {
    const count = report.cycles;
    parts.push(`${count} value${count === 1 ? "" : "s"} referring back to itself was cut.`);
  }
  return parts.length > 0 ? parts.join(" ") : void 0;
}
__name(sanitizeNote, "sanitizeNote");
function blockLabel(result) {
  return result?.source.kind === "url" ? "openapi (url)" : "openapi";
}
__name(blockLabel, "blockLabel");
//# sourceMappingURL=presentation.js.map
